import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import LoungeListPanel from "container/lounge/LoungeListPanel";
import LoginRecommendationView from "presentational/lounge/LoginRecommendationView";
import { withStore } from "store/storeHandler";
import { getEssentialUrl } from "lib/urlQueryParser";
import GaHelper from "lib/gaHelper";

function RootLounge(props) {
  const { isLoading, outfitList, LoungeActions, AppErrorActions } = props;

  const history = useHistory();

  useEffect(() => {
    initLoungeList();
  }, []);

  const initLoungeList = async () => {
    try {
      await LoungeActions.initList();
    } catch (error) {
      AppErrorActions.setSafeAppError(error);
    }
  };

  const handleLoginRecommendationBtnClick = loc => () => {
    history.push(getEssentialUrl({ type: "account", allowRefParam: true })());

    GaHelper.setGAClickEvent({ type: "logInRecommendationBtn", loc });
  };

  return (
    <div>
      <LoungeListPanel list={outfitList} isLoading={isLoading} />
      <LoginRecommendationView
        bottomView
        onLoginRecommendationBtnClick={handleLoginRecommendationBtnClick(
          "loungePage-lower"
        )}
      />
    </div>
  );
}

export default withStore({
  stateMap: { lounge: ["outfitList", "isLoading"] },
  dispatchMap: ["lounge", "appError"]
})(RootLounge);
